import React from "react";
import { CheckCircle, AlertTriangle, Info } from "lucide-react";
import { cn } from "@/lib/utils";

interface ToastCardProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  variant?: "default" | "destructive" | "success" | "info" | "warning";
  action?: React.ReactNode;
}

export const ToastCard: React.FC<ToastCardProps> = ({ title, description, variant = "default", action }) => {
  const isDestructive = variant === "destructive";

  return (
    <div className={cn(
      "flex w-full items-start gap-3",
      // Rely on outer Toast container for border, padding, background
      isDestructive ? "" : ""
    )}>
      <div className={cn(
        "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-muted/50",
        isDestructive ? "text-destructive" : "text-primary"
      )}>
        {isDestructive ? <AlertTriangle className="h-4 w-4" /> : variant === "warning" ? <AlertTriangle className="h-4 w-4" /> : variant === "info" ? <Info className="h-4 w-4" /> : <CheckCircle className="h-4 w-4" />}
      </div>
      <div className="min-w-0 flex-1">
        {title ? <div className="font-medium text-foreground break-words whitespace-pre-wrap">{title}</div> : null}
        {description ? (
          <div className="mt-0.5 text-sm text-muted-foreground break-words whitespace-pre-wrap">{description}</div>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
};
